/**
 * @module SalesFlow/evolved/router
 */

import {RouterEvolvedInlifeRecommendation} from 'router-evolved/inlife/router-evolved--inlife-recommendation';
import {Constants} from 'core/constants';

/**
 * @TODO don't use injector as dependency
 */
export class RouterEvolvedFamilyFriendsInlifeRecommendation extends RouterEvolvedInlifeRecommendation {

    /**
     * For soho sales channel is always soho
     */
    protected setSalesChannel (): void {

        this._salesChannel = Constants.SALESCHANNEL_FAMILY_FRIENDS;

    }

}
